import debug from 'debug';
import { beginTask, endTask } from 'redux-nprogress';

import * as types from './auth.types';
import { goToView } from '../../app/routes.global';
import { CUSTOM_LEAGUE_VIEW } from '../../app/views/Custom/module/custom';
import { GO_HOME } from './home.types';
import { GO_LOGIN, GO_LOGOUT } from './auth.types';

const log = debug('huddle:store:actions:auth');

export const goLogin = { type: types.GO_LOGIN };

export const selectAuthState = state => state[types.STORE_KEY];

export const resetLoginState = { type: types.RESET_AUTH_STATE };

export const loginAction = async (dispatch, getState, { api }) => {
  dispatch(beginTask());
  const credentials = getState().auth.credentials;
  const currentPath = getState().location.pathname;
  const referrerURL = getState().location.search;
  const previousPath = getState().location.prev.pathname;

  dispatch({ type: types.LOGGING_IN });
  try {
    const { user } = await api.user.login(credentials);
    dispatch({
      type: types.LOGGED_IN,
      payload: {
        user,
      },
    });
    // Return to WP article Referrer
    if (typeof window !== 'undefined' && typeof referrerURL !== 'undefined' && referrerURL.includes('return_to')) {
      if (document.referrer.includes('thehuddle.com') || (process.env.ELB_ENV && process.env.ELB_ENV !== 'local')) {
        return document.location.href = `https://thehuddle.com/redirect-page?${referrerURL}`;
      } else {
        return document.location.href = `https://thehuddle.stagesmg.com/redirect-page?${referrerURL}`;
      }
    }
    if (currentPath === '/' || currentPath === '/login') {
      if (typeof window !== 'undefined') {
        var referrer = document.referrer;
        var fromTheHuddle = referrer.includes('thehuddle.com');
        if (fromTheHuddle & !referrer.includes('/logout')) {
          return document.location.href = referrer;
        }
      }
      return dispatch(goToView(CUSTOM_LEAGUE_VIEW));
    }
  } catch (error) {
    // conditional for flagged users needing password reset
    if (error.message.includes('Password change required')) {
      const email = error.email;
      document.cookie = "huddleResetEmail=" + email + "; expires=Tue, 31 Dec 2030 12:00:00 UTC; path=/";
      var resetEmail = error.message.split('|')[1];
      document.cookie = "huddleEmail=" + resetEmail + "; expires=Tue, 31 Dec 2030 12:00:00 UTC; path=/";
      return document.location.href = '/must-reset-password';
    }
    log('error from call to api.user.login:', { credentials }, error);
    return dispatch({
      type: types.AUTH_ERROR,
      error,
      payload: {
        credentials,
      },
    });
  } finally {
    // end NProgress bar task
    dispatch(endTask());
  }
};

export const logoutAction = async (dispatch, getState, { api }) => {
  dispatch(beginTask());
  dispatch({ type: types.LOGGING_OUT });

  try {
    await api.user.logout();
    dispatch({
      type: types.LOGGED_OUT,
    });
    return dispatch(goToView(GO_LOGOUT));
  } catch (error) {
    log('error from call to api.user.logout:', error);
    return dispatch({
      type: types.AUTH_ERROR,
      error,
      payload: { },
    });
  } finally {
    // end NProgress bar task
    dispatch(endTask());
  }
}


// RETURN to URL
export const returnToURl = url => {
  return {
    type: types.REFERRER_URL,
    payload: url,
  };
};



// WEBPACK FOOTER //
// ./src/store/actions/auth.actions.js